import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/Master-Games.eu.png'


const _withScopeId = n => (_pushScopeId("data-v-6d581759"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar fixed-top navbar-expand-lg navbar-light bg-light" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "navbar-brand",
  src: _imports_0,
  alt: "logo",
  height: "50",
  width: "120"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = {
  class: "nav-link active",
  "aria-current": "page",
  href: "#"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-link" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Donation")
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-link" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Contact")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("a", _hoisted_11, [
                _createVNode(_component_router_link, { to: "/store" }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createElementVNode("a", _hoisted_14, [
                _createVNode(_component_router_link, { to: "/kontakty" }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}